import { runtimeConfig } from '@/shared/config'

// SSO сотрудника (00-architecture § 3): пароля у сотрудника нет, вход только
// через Authentik — единый BFF id.stit.tech, ?rd= возвращает обратно. Прямо сюда
// никто не редиректит: единственная точка входа экосистемы — /login
// (22-unified-login), а этот адрес — то, куда ведёт с него кнопка Authentik.

// returnTo не задан или отброшен политикой rd — уходим без ?rd: BFF подставит
// свой DefaultURL (authgate/redirect.go), и это честнее выдуманного адреса.
export function loginUrl(returnTo?: string): string {
  const base = `${runtimeConfig.ID_BASE_URL}/auth/login`
  return returnTo ? `${base}?rd=${encodeURIComponent(returnTo)}` : base
}

// Контракт хаба — POST /auth/logout (state-changing; GET → 405 и уязвим к
// prefetch/CSRF-логауту), поэтому не location.assign, а form-POST навигация:
// same-site POST на id.stit.tech шлёт hub-cookie без CORS, браузер сам
// следует 302 на ?rd=.
export function redirectToLogout(returnTo: string = window.location.origin): void {
  const form = document.createElement('form')
  form.method = 'post'
  form.action = `${runtimeConfig.ID_BASE_URL}/auth/logout?rd=${encodeURIComponent(returnTo)}`
  document.body.appendChild(form)
  form.submit()
}
